import { Box, Typography } from '@mui/material'
import { RouteProps } from '../../routes/AppRouter'
import styles from './PrivacyPolicy.module.css'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { HeaderPolicy } from '../../components/header-policy/HeaderPolicy'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'
import { LoggedUser } from '../../modules/users/models/LoggedUser'
import { getUserContainer } from '../../container/user-module'
import { ILoggedUserService } from '../../modules/users/services/LoggedUserService'
import { LOGGED_USER_SERVICE_KEY } from '../../modules/users'
import { PageLayout } from '../layout/PageLayout'

const loggedUserService = getUserContainer().get<ILoggedUserService>(LOGGED_USER_SERVICE_KEY)

export function PrivacyPolicy(props: RouteProps) {
  const loggedUser = loggedUserService.get()
  const title = props.title || ''
  const [user, setUser] = useState<LoggedUser | undefined>(loggedUser)
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)
  const { t } = useTranslation()

  useEffect(() => {
    const subscription = loggedUserService.getObservable().subscribe((lu) => {
      setUser(lu)
    })
    return () => subscription.unsubscribe()
  }, [])

  return (
    <>
      {user ? (
        <PageLayout scrollable withCard={true}>
          <Box className={styles.containterLogin}>
            <Box display="flex" justifyContent="center">
              <Box className={styles.contentLogin}>
                <h4 className={styles.titleParrafLogin}>{t('dataControllerTitle')}</h4>
                <Typography className={styles.parraphLogin}>{t('dataControllerParraf')}</Typography>

                <h4 className={styles.titleParrafLogin}>{t('areaOfAplicationTitle')}</h4>
                <Typography className={styles.parraphLogin}>
                  {t('areaOfAplicationParraf')}
                </Typography>

                <h4 className={styles.titleParrafLogin}>{t('purposesTheCollectionTitle')}</h4>
                <Typography className={styles.parraphLogin}>
                  {t('purposesTheCollectionParraf')}
                </Typography>

                <h4 className={styles.titleParrafLogin}>{t('periodConservationTitle')}</h4>
                <Typography className={styles.parraphLogin}>
                  {t('periodConservationParraf')}
                </Typography>

                <h4 className={styles.titleParrafLogin}>{t('recipientsPersonalDataTitle')}</h4>
                <Typography className={styles.parraphLogin}>
                  {t('recipientsPersonalDataParraf')}
                </Typography>

                <h4 className={styles.titleParrafLogin}>{t('rightOfUsersTitle')}</h4>
                <Typography className={styles.parraphLogin}>{t('rightOfUsersParraf')}</Typography>

                <h4 className={styles.titleParrafLogin}>{t('controlAuthorityTitle')}</h4>
                <Typography className={styles.parraphLogin}>
                  {t('controlAuthorityParraf')}
                </Typography>

                <h4 className={styles.titleParrafLogin}>{t('aicrumitDataProcessorTitle')}</h4>
                <Typography className={styles.parraphLogin}>
                  {t('aicrumitDataProcessorParraf')}
                </Typography>

                <h4 className={styles.titleParrafLogin}>{t('infoDataProtectionTitle')}</h4>
                <Typography className={styles.parraphLogin}>
                  {t('infoDataProtectionParraf')}
                </Typography>
              </Box>
            </Box>
          </Box>
        </PageLayout>
      ) : (
        <Box className={styles.containter}>
          <Box display="flex" justifyContent="center">
            <HeaderPolicy title={t('privacyPolicy')} />
            <Box className={styles.content}>
              <h1 className={styles.titleHeader}>{t('privacyPolicy')}</h1>

              <h4 className={styles.titleParraf}>{t('dataControllerTitle')}</h4>
              <Typography className={styles.parraph}>{t('dataControllerParraf')}</Typography>

              <h4 className={styles.titleParraf}>{t('areaOfAplicationTitle')}</h4>
              <Typography className={styles.parraph}>{t('areaOfAplicationParraf')}</Typography>

              <h4 className={styles.titleParraf}>{t('purposesTheCollectionTitle')}</h4>
              <Typography className={styles.parraph}>{t('purposesTheCollectionParraf')}</Typography>

              <h4 className={styles.titleParraf}>{t('periodConservationTitle')}</h4>
              <Typography className={styles.parraph}>{t('periodConservationParraf')}</Typography>

              <h4 className={styles.titleParraf}>{t('recipientsPersonalDataTitle')}</h4>
              <Typography className={styles.parraph}>
                {t('recipientsPersonalDataParraf')}
              </Typography>

              <h4 className={styles.titleParraf}>{t('rightOfUsersTitle')}</h4>
              <Typography className={styles.parraph}>{t('rightOfUsersParraf')}</Typography>

              <h4 className={styles.titleParraf}>{t('controlAuthorityTitle')}</h4>
              <Typography className={styles.parraph}>{t('controlAuthorityParraf')}</Typography>

              <h4 className={styles.titleParraf}>{t('aicrumitDataProcessorTitle')}</h4>
              <Typography className={styles.parraph}>{t('aicrumitDataProcessorParraf')}</Typography>

              <h4 className={styles.titleParraf}>{t('infoDataProtectionTitle')}</h4>
              <Typography className={styles.parraph}>{t('infoDataProtectionParraf')}</Typography>
            </Box>
          </Box>
        </Box>
      )}
    </>
  )
}
